'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = regexpValidator;
function regexpValidator(options) {
  var message = options.message;

  var pattern = options.pattern instanceof RegExp ? options.pattern : new RegExp(options.pattern);

  return function (input) {
    if (!pattern.test(input)) {
      return message || 'must match the pattern: ' + String(pattern);
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ../flow-runtime-validators/lib/regexp.js
// module id = 297
// module chunks = 0